module.exports = __webpack_public_path__ + "d664201f/img/document.e2130c6b.svg";